import React from 'react'

const BannerSlide = () => {
  return (
    <div className="w-full h-full flex flex-col justify-center px-[25vh] py-10">
        <div className='mb-4'>
           <h1 className="text-purple-900 font-extrabold max-w-3xl text-2xl lg:text-5xl font-nunito">DOG FOOD MARKET </h1>
           <h1 className='text-purple-900 font-extrabold max-w-3xl text-2xl lg:text-5xl font-nunito'>LANDSCAPE</h1>
        </div>
        <div>
               <h2 className="text-[#E85D04] mt-4 text-xl lg:text-3xl max-w-4xl">Consumer Behaviors & Emerging</h2>
               <h2 className="text-[#E85D04] text-xl lg:text-3xl max-w-4xl">Trends</h2>
        </div>
      </div>
  )
}

export default BannerSlide